import React from "react";
import { Container } from "react-bootstrap";
import SlideInText from "./AppComponents/SlideInText";

const AboutMe = () => {
  return (
    <div id="about">
      <Container className="text-light">
        <h3 className="text-accent">About Me</h3>
        <hr />

        <SlideInText
          text="🔹 I'm a Self Taught ReactJS FrontEnd/NodeJS BackEnd//Web3 Programmer."
          duration={1}
          delay={0}
        />
        <SlideInText
          text="🔹 I'm very Passionate on learning New Technologies Everyday."
          duration={1}
          delay={0.2}
        />
        
        <SlideInText
          text="🔹 Having Knowledge On ReactJS/NodeJS RESTful Server/GraphQL API using
          ExpressJS with MVC Pattern in SQL and No SQL Databases"
          duration={1}
          delay={0.4}
        />
        
      </Container>
    </div>
  );
};

export default AboutMe;
